__webpack_require__.p = "/elections/legislative-details/";